
import React, { useEffect, useState } from 'react';
import {
  Container,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  CircularProgress,
  Alert,
  Divider,
  Paper,
  Grid,
  Chip,
  Avatar,
  Fade,
  Slide,
  Zoom
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  Person as PersonIcon,
  AttachMoney as MoneyIcon,
  Payment as PaymentIcon,
  Security as SecurityIcon,
  CheckCircle as CheckCircleIcon,
  AccountBalance as BankIcon,
  CreditCard as CreditCardIcon
} from '@mui/icons-material';
import Cookies from "universal-cookie";
import axios from "axios";
import host, { Host } from "../../../assets/js/Host";
import { toast } from 'react-toastify';
import CaptchaDialog from './CaptchaDialog';
import { useSelector } from 'react-redux';

const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function GuestOnlinePayment() {
  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [billNumber, setBillNumber] = useState('');
  const [error, setError] = useState('');
  const [captchaDialogOpen, setCaptchaDialogOpen] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const themeData = useSelector((state) => state.themeData);

  // Extract bill number from URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const billParam = urlParams.get('bill_number');
    
    if (billParam) {
      setBillNumber(billParam);
      fetchInvoiceDetails(billParam);
    } else {
      setError('Bill number not found in URL');
    }
  }, []);

  // Fetch invoice details from API
  const fetchInvoiceDetails = async (billNum) => {
    setLoading(true);
    setError('');
    var response=null
    try {
      response = await axios({
        method: 'GET',
        url:`${host}show_invoice_details?bill_number=${billNum}`,
        headers: {
          'Content-Type': 'application/json',
        }
      });
      console.log('response.data',response.data)
      if (response.data && response.data.success) {
        setInvoiceData(response.data.data);
      }else if(response.data.message&&typeof response.data.message=='string'){
        setError(response.data.message);
        toast.error(response.data.message);
      } else {
        setError('Invoice not found or invalid');
      }
    } catch (error) {
      const responseResult = error.response

      console.error('Error fetching invoice:', responseResult);
      if(responseResult.data.message&&typeof responseResult.data.message=='string'){
        setError(responseResult.data.message);
        toast.error(responseResult.data.message);
      }else if(responseResult.data.data&&typeof responseResult.data.data=='string'){
        setError(responseResult.data.data);
        toast.error(responseResult.data.data);
      }else {
        setError('Failed to load invoice details. Please try again.');
        toast.error('Failed to load invoice details. Please try again.');
      }
     
      
    } finally {
      setLoading(false);
    }
  };

  // Handle payment button click
  const handlePayClick = () => {
    setCaptchaDialogOpen(true);
  };

  // Handle captcha verification
  const handleCaptchaVerify = async (captchaToken) => {
    setPaymentLoading(true);
    const newWindow = window.open('', '_blank');
    
    try {
      // Verify captcha and process payment
      const response = await axios.post(`${host}guest_register_by_invoice_number`, {
        bill_number: billNumber,
        captcha_token: captchaToken,
        amount: invoiceData?.amount,
        invoice_id: invoiceData?.invoice_id,
      });
      console.log('Object',response.data);
      if (response.data && response.data.success) {
        toast.success('Payment processed successfully!');
        // Redirect to payment gateway or success page
        // Open the window immediately on user click, before the async operation
        if (response?.data?.data?.data?.formUrl) {
          newWindow.location.href = response.data.data.data.formUrl;
        }else{
          newWindow.close(); // Close if no URL received
        }
      }else if(response.data?.data&&typeof response.data.data === 'string') {
         newWindow.close(); // Close if no URL received
        toast.error(response.data.data)
      }else {
        newWindow.close(); // Close if no URL received
        toast.error("فشل في معالجة الدفع. يرجى المحاولة مرة أخرى.");
      }

    } catch (error) {
      newWindow.close(); // Close if no URL received
      const responseResult = error.response
      console.error('Error fetching invoice:', responseResult);
      if(responseResult.data.message&&typeof responseResult.data.message=='string'){
        // setError(responseResult.data.message);
        toast.error(responseResult.data.message);
      }else if(responseResult.data.data&&typeof responseResult.data.data=='string'){
        // setError(responseResult.data.data);
        toast.error(responseResult.data.data);
      }else {
        // setError("فشل في معالجة الدفع. يرجى المحاولة مرة أخرى.");
        toast.error("فشل في معالجة الدفع. يرجى المحاولة مرة أخرى.");
      }
    } finally {
      setPaymentLoading(false);
      setCaptchaDialogOpen(false);
    }
  };

  // Handle captcha dialog close
  const handleCaptchaClose = () => {
    setCaptchaDialogOpen(false);
    setPaymentLoading(false);
  };

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #1e6a99 0%, #2980b9 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="4"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            animation: 'float 6s ease-in-out infinite'
          }
        }}
      >
        <Container maxWidth="md" sx={{ py: 8, minHeight: '100vh', fontFamily: 'Cairo, sans-serif' }}>
          <Fade in={true}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box
                sx={{
                  position: 'relative',
                  mb: 3
                }}
              >
                <CircularProgress 
                  size={80} 
                  thickness={4}
                  sx={{
                    color: 'white',
                    filter: 'drop-shadow(0 4px 20px rgba(255,255,255,0.3))'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                  }}
                >
                  <ReceiptIcon sx={{ fontSize: 32, color: 'white' }} />
                </Box>
              </Box>
              <Typography 
                variant="h5" 
                sx={{ 
                  color: 'white',
                  fontWeight: 600,
                  textAlign: 'center',
                  textShadow: '0 2px 10px rgba(0,0,0,0.3)'
                }}
              >
              جاري تحميل تفاصيل الفاتورة...
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'rgba(255,255,255,0.8)',
                  mt: 1,
                  textAlign: 'center'
                }}
              >
                يرجى الانتظار بينما نقوم بجلب معلومات الدفع الخاصة بك
              </Typography>
            </Box>
          </Fade>
        </Container>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg,rgb(241, 241, 241) 0%,rgb(239, 239, 239) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}
      >
        <Container maxWidth="md">
          <Fade in={true}>
            <Paper
              elevation={24}
              sx={{
                p: 6,
                textAlign: 'center',
                borderRadius: 4,
                background: 'rgba(255,255,255,0.95)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.2)',
                
              }}
            >
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  bgcolor: '#ff6b6b',
                  mx: 'auto',
                  mb: 3
                }}
              >
                <ReceiptIcon sx={{ fontSize: 40 }} />
              </Avatar>
              <Typography  fontWeight="bold" color="error" gutterBottom
               sx={{
                fontFamily: 'Cairo',
                fontSize: {sx:'22px', md:'25px', lg:'30px'},
               }}
              >
              عفواً! حدث خطأ ما              
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 4,fontFamily: 'Cairo', }}>
                {error}
              </Typography>
              <Button 
                variant="contained" 
                size="large"
                onClick={() => fetchInvoiceDetails(billNumber)}
                sx={{
                  background: 'linear-gradient(45deg, #ff6b6b 30%, #ee5a24 90%)',
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 600,
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(255, 107, 107, 0.3)',
                  fontFamily: 'Cairo',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(255, 107, 107, 0.4)'
                  }
                }}
              >
                حاول مرة أخرى
              </Button>
            </Paper>
          </Fade>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        py: 4,
      }}
    >
      <Container maxWidth="md" >
        <Fade in={true} timeout={600}>
          <Paper 
            elevation={0} 
            sx={{ 
              borderRadius: 3,
              overflow: 'hidden',
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
            }}
          >
            {/* Header */}
            <Box 
              sx={{ 
                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                color: 'white',
                p: 4,
                textAlign: 'center'
              }}
            >
              <Avatar
                sx={{
                  width: 64,
                  height: 64,
                  bgcolor: 'rgba(255,255,255,0.15)',
                  mx: 'auto',
                  mb: 2
                }}
              >
                <ReceiptIcon sx={{ fontSize: 32 }} />
              </Avatar>
              <Typography 
                variant="h4" 
                fontWeight="600" 
                sx={{
                   mb: 1,
                   fontFamily: 'Cairo',
               }}
              >
                دفع الفواتير
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  opacity: 0.9,
                  fontWeight: 400,
                  fontFamily: 'Cairo',

                }}
              >
            معالجة الدفع بشكل آمن وسريع 
              </Typography>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                <Chip 
                  icon={<SecurityIcon sx={{ fontSize: 16,fill:"#fff" }} />} 
                  label="Secure" 
                  size="small"
                  sx={{ 
                    bgcolor: 'rgba(255,255,255,0.15)',
                    color: 'white',
                    fontSize: '0.75rem'
                  }} 
                />
                <Chip 
                  icon={<CheckCircleIcon sx={{ fontSize: 16,fill:"#fff" }} />} 
                  label="Verified" 
                  size="small"
                  sx={{ 
                    bgcolor: 'rgba(255,255,255,0.15)',
                    color: 'white',
                    fontSize: '0.75rem'
                  }} 
                />
              </Box>
            </Box>

            <CardContent sx={{ p: 4 }}>
          {invoiceData ? (
            <>
              {/* Bill Details */}
              <Box 
                sx={{
                  display: 'flex',
                  justifyContent:"flex-end",
                  alignItems: 'center',
                }}
              >
              <Typography variant="h5" fontWeight="600" sx={{ 
                mb: 3, color: '#1f2937' ,
                fontFamily: 'Cairo',
              }}>
                بيانات الفاتورة
              </Typography>
              </Box>
              <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={4}>
                  <Card 
                    sx={{ 
                      height: '100%',
                      background: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: 2,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        borderColor: '#3b82f6'
                      }
                    }}
                  >
                    <CardContent sx={{ textAlign: 'center', p: 3 }}>
                      <Avatar
                        sx={{
                          width: 48,
                          height: 48,
                          bgcolor: '#3b82f6',
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        <ReceiptIcon sx={{ fontSize: 24 }} />
                      </Avatar>
                      <Typography variant="body2" fontWeight="500" gutterBottom color="#6b7280"
                       sx={{
                  fontFamily: 'Cairo',

                       }}
                      
                      >
                        رقم الفاتورة
                      </Typography>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          color: '#1f2937',
                          fontWeight: '600'
                        }}
                      >
                        {invoiceData.bill_number || billNumber}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Card 
                    sx={{ 
                      height: '100%',
                      background: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: 2,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        borderColor: '#10b981'
                      }
                    }}
                  >
                    <CardContent sx={{ textAlign: 'center', p: 3 }}>
                      <Avatar
                        sx={{
                          width: 48,
                          height: 48,
                          bgcolor: '#10b981',
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        <PersonIcon sx={{ fontSize: 24 }} />
                      </Avatar>
                      <Typography variant="body2" fontWeight="500" gutterBottom color="#6b7280"
                       sx={{
                  fontFamily: 'Cairo',

                       }}
                      >
                        اسم الزبون
                      </Typography>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          color: '#1f2937',
                          fontWeight: '600',
                          wordBreak: 'break-word',
                          fontFamily:'Cairo',
                          fontSize:'17px'
                        }}
                      >
                        {invoiceData.customer_name || 'N/A'}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Card 
                    sx={{ 
                      height: '100%',
                      background: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: 2,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        borderColor: '#f59e0b'
                      }
                    }}
                  >
                    <CardContent sx={{ textAlign: 'center', p: 3 }}>
                      <Avatar
                        sx={{
                          width: 48,
                          height: 48,
                          bgcolor: '#f59e0b',
                          mx: 'auto',
                          mb: 2
                        }}
                      >
                        <MoneyIcon sx={{ fontSize: 24 }} />
                      </Avatar>
                      <Typography variant="body2" fontWeight="500" gutterBottom color="#6b7280"
                        sx={{
                          fontFamily: 'Cairo',
                        }}
                      >
                       المبلغ المستحق
                      </Typography>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          color: '#1f2937',
                          fontWeight: '600'
                        }}
                      >
                        {invoiceData.currency || 'USD'} {invoiceData.amount || '0.00'}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>

              <Divider sx={{ my: 4 }} />

              {/* Additional Bill Information */}
              {(invoiceData.description || invoiceData.due_date) && (
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h5" fontWeight="600" sx={{ mb: 3, color: '#1f2937' ,
                   fontFamily: 'Cairo',
                  }}>
                    معلومات اضافية عن الفاتورة
                  </Typography>
                  <Grid container spacing={3}>
                    {invoiceData.description && (
                      <Grid item xs={12} md={6}>
                        <Card
                          sx={{
                            p: 3,
                            background: '#ffffff',
                            border: '1px solid #e5e7eb',
                            borderRadius: 2
                          }}
                        >
                          <Typography variant="subtitle2" fontWeight="600" color="#6b7280" gutterBottom
                          sx={{
                            fontFamily: 'Cairo',
                          }}
                          >
                            الوصف
                          </Typography>
                          <Typography variant="body2" sx={{ lineHeight: 1.6, color: '#1f2937' }}>
                            {invoiceData.description}
                          </Typography>
                        </Card>
                      </Grid>
                    )}
                    {invoiceData.due_date && (
                      <Grid item xs={12} md={6}>
                        <Card
                           sx={{
                             p: 3,
                             background: '#ffffff',
                             border: '1px solid #e5e7eb',
                             borderRadius: 2
                           }}
                         >
                           <Typography variant="subtitle2" fontWeight="600" color="#6b7280" gutterBottom
                             sx={{
                              fontFamily: 'Cairo',
                             }}
                           >
                            تاريخ الاستحقاق
                           </Typography>
                           <Typography variant="body2" fontWeight="600" color="#1f2937">
                             {new Date(invoiceData.due_date).toLocaleDateString('en-US', {
                               weekday: 'long',
                               year: 'numeric',
                               month: 'long',
                               day: 'numeric'
                             })}
                           </Typography>
                         </Card>
                       </Grid>
                     )}
                   </Grid>
                 </Box>
               )}

              {/* Payment Section */}
              <Box sx={{ mt: 4 }}>
                <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
                >
                  <Typography variant="h5" fontWeight="600" sx={{ mb: 3, color: '#1f2937', fontFamily: 'Cairo',}}>
                    الدفع
                  </Typography>
                </Box>
                <Card
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    background: '#ffffff',
                    border: '1px solid #e5e7eb',
                    borderRadius: 2
                  }}
                >
                  <Typography 
                    variant="h6" 
                    fontWeight="600" 
                    gutterBottom
                    sx={{
                      color: '#1f2937',
                      mb: 3,
                      fontFamily: 'Cairo',
                    }}
                  >
                   جاهز للدفع الآن؟
                  </Typography>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 4,overflowX: 'auto' }} className="no-scrollbar">
                    <Chip 
                      icon={<CreditCardIcon />} 
                      label="Credit Card" 
                      sx={{ 
                        bgcolor: '#f3f4f6',
                        color: '#374151',
                        fontWeight: 500,
                        border: '1px solid #e5e7eb'
                      }} 
                    />
                    <Chip 
                      icon={<BankIcon />} 
                      label="Bank Transfer" 
                      sx={{ 
                        bgcolor: '#f3f4f6',
                        color: '#374151',
                        fontWeight: 500,
                        border: '1px solid #e5e7eb'
                      }} 
                    />
                    <Chip 
                      icon={<SecurityIcon />} 
                      label="Secure" 
                      sx={{ 
                        bgcolor: '#f3f4f6',
                        color: '#374151',
                        fontWeight: 500,
                        border: '1px solid #e5e7eb'
                      }} 
                    />
                  </Box>

                  <Button
                    variant="contained"
                    size="large"
                    onClick={handlePayClick}
                    disabled={paymentLoading}
                    startIcon={paymentLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : <PaymentIcon />}
                    sx={{
                      background: '#3b82f6',
                      color: 'white',
                      px: 6,
                      py: 2,
                      fontSize: '1rem',
                      fontWeight: '600',
                      borderRadius: 2,
                      textTransform: 'none',
                      fontFamily: 'Cairo',
                      boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                      '&:hover': {
                        background: '#2563eb',
                        boxShadow: '0 6px 16px rgba(59, 130, 246, 0.4)'
                      },
                      '&:disabled': {
                        background: '#9ca3af',
                        boxShadow: 'none'
                      }
                    }}
                  >
                    {paymentLoading ? 'جاري معالجة الدفع...' : 'ادفع الآن'}
                  </Button>
                  
                  <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    <SecurityIcon sx={{ fontSize: 16, color: '#6b7280' }} />
                    <Typography variant="body2" color="#6b7280" fontWeight={500}>
                      Protected by advanced encryption & reCAPTCHA verification
                    </Typography>
                  </Box>
                  
                  <Typography variant="caption" color="#9ca3af" sx={{ mt: 2, display: 'block' }}>
                    Your payment information is secure and encrypted using industry-standard SSL technology
                  </Typography>
                </Card>
              </Box>
            </>
          ) : (
            <Alert severity="warning">
               لا تتوفر بيانات الفاتورة 
            </Alert>
          )}
            </CardContent>
          </Paper>
        </Fade>
      </Container>

      {/* Captcha Dialog */}
      {captchaDialogOpen?<CaptchaDialog
        open={captchaDialogOpen}
        onClose={handleCaptchaClose}
        onVerify={handleCaptchaVerify}
        loading={paymentLoading}
      />:null}
    
    </Box>
  );
}

export default GuestOnlinePayment;